import { useState } from 'react';

import { clsx } from 'clsx';
import { useCopyToClipboard } from 'usehooks-ts';

import Copy from '@/components/Icons/Copy';
import { ICardAdmin } from '@/types/ICard';

const CardUrlCell: React.FC<{ card: ICardAdmin }> = ({ card }) => {
  const [, copy] = useCopyToClipboard();
  const [urlCopied, setUrlCopied] = useState(false);

  const cardUrl = card.card_page_url;
  async function copyUrlToClipboard() {
    await copy(cardUrl);

    setUrlCopied(true);
    setTimeout(() => {
      setUrlCopied(false);
    }, 3000);
  }

  return (
    <td className={'p-4 pb-3 hidden md:table-cell'}>
      <div className="relative inline-block">
        <div className="hover:cursor-pointer" onClick={copyUrlToClipboard}>
          <Copy
            className={clsx(
              'w-6 h-6',
              urlCopied ? 'text-brand-500' : 'text-gray-400',
            )}
          />
        </div>
        {urlCopied && (
          <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 px-2 py-1 bg-brand-100 rounded text-brand-500 text-sm font-medium font-poppins whitespace-nowrap">
            Copied!
          </div>
        )}
      </div>
    </td>
  );
};

export default CardUrlCell;
